import script from "./ActionBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionBox.vue?vue&type=script&setup=true&lang=js"

import "./ActionBox.vue?vue&type=style&index=0&id=7c461a82&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c461a82"]])

export default __exports__